import React, { useState, useEffect } from "react";
import { sponsorService } from "../../api/sponsor.service";

function Carousel({ setSponsorId, setIsOpenSponsor }) {
	const [startIndex, setStartIndex] = useState(0);
	const [sponsors, setSponsors] = useState([]);
	const [visibleCount, setVisibleCount] = useState(7);

	useEffect(() => {
		const updateVisibleCount = () => {
			if (window.innerWidth <= 768) {
				setVisibleCount(3);
			} else {
				setVisibleCount(7);
			}
		};

		updateVisibleCount();
		window.addEventListener("resize", updateVisibleCount);
		return () => window.removeEventListener("resize", updateVisibleCount);
	}, []);

	useEffect(() => {
		sponsorService
			.list()
			.then((response) => {
				setSponsors(response.results);
			})
			.catch((err) => {
				console.error("Error fetching sponsors:", err);
			});
	}, []);

	const canScrollLeft = startIndex > 0;
	const canScrollRight = startIndex + visibleCount < sponsors.length;

	const handlePrev = () => {
		if (canScrollLeft) {
			setStartIndex(startIndex - 1);
		}
	};

	const handleNext = () => {
		if (canScrollRight) {
			setStartIndex(startIndex + 1);
		}
	};

	const visibleItems = sponsors.slice(startIndex, startIndex + visibleCount);
	if (!sponsors.length) return null;

	return (
		<div className="carousel" aria-label="Featured sponsors">
			<button
				type="button"
				className="carousel-btn"
				onClick={handlePrev}
				disabled={!canScrollLeft}
				aria-label="Previous sponsors"
			>
				<i className="fas fa-chevron-left" aria-hidden="true" />
			</button>
			<div className="carousel-items">
				{visibleItems.map((item) => (
					<button
						type="button"
						className="carousel-item"
						key={item.id}
						onClick={() => {
							setSponsorId(item.id);
							setIsOpenSponsor(true);
						}}
						aria-label={`View sponsored horses from ${item.name}`}
					>
						<img
							src={item.logo}
							alt={item.name}
							className="sponsor-logo"
						/>
					</button>
				))}
			</div>
			<button
				type="button"
				className="carousel-btn"
				onClick={handleNext}
				disabled={!canScrollRight}
				aria-label="Next sponsors"
			>
				<i className="fas fa-chevron-right" aria-hidden="true" />
			</button>
		</div>
	);
}

export default Carousel;
